import React from 'react';
import PropTypes from 'prop-types';
import './styles/toggle.scss';

const ToggleButton = ({
    toggleText = '',
    isToggleOn = false,
    gtmAttribute = '',
    setToggleState = () => null,
}) => {

    return (
        <div className="toggleButton">
            <div className="toggleButton__text">{toggleText}</div>
            <div
                className={isToggleOn ? 'toggleButton__switch toggleButton__switch--active' : 'toggleButton__switch'}
                onClick={() => setToggleState(!isToggleOn)}
                data-spectate-product={gtmAttribute}
            />
        </div>
    );
};

ToggleButton.propTypes = {
    toggleText: PropTypes.string,
    isToggleOn: PropTypes.bool,
    gtmAttribute: PropTypes.string,
    setToggleState: PropTypes.func,
};

export default ToggleButton;
